import React, { useState, useEffect } from 'react'
import SelectNationality from './SelectNationality'
import EnterIDPass from './EnterIDPass'
import { Container, Divider, OutlinedInput, Box, Grid, TextField, Typography, Button, InputLabel, FormControl, Select, MenuItem, CircularProgress } from '@mui/material/'
import { useFetch } from '../hooks/useFetch'
import DashboardIcon from '@mui/icons-material/Dashboard';
import SelectRace from './SelectRace'
import SelectSALang from './SelectSALang'
import SelectGender from './SelectGender'
import EnterEmail from './EnterEmail'
import SelectPreviousGrade from './SelectPreviousGrade'
import { useAuthContext } from '../hooks/useAuthContext'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SelectRelationship from './SelectRelationship'
import SelectTitle from './SelectTitle'
import SelectCountry from './SelectCountry'
import SelectSaProvince from './SelectSaProvince'

function CreateStudent({ setCreateStudent }) {
    const { accessLevel, parentID } = useAuthContext()
    const { postData: CheckStudentIDPass, data: studentIDPASSCheck, error, errorMessage, isPending } = useFetch(`https://dcregapi.bi-oss.co.za/students/idpasscountall`, 'POST')
    const { postData: CheckStudentEmail, data: studentEmailCheck, error: error2, errorMessage: errorMessage2, isPending: isPending2 } = useFetch(`https://dcregapi.bi-oss.co.za/students/emailcount`, 'POST')


    const { postData: CheckParentIDPASS, data: parentIDPASSCheck, error: error3, errorMessage: errorMessage3, isPending: isPending3 } = useFetch(`https://dcregapi.bi-oss.co.za/parents/idpasscountall`, 'POST')
    const { postData: CheckParentEmail, data: parentEmailChecked, error: error4, errorMessage: errorMessage4, isPending: isPending4 } = useFetch(`https://dcregapi.bi-oss.co.za/parents/emailcount`, 'POST')

    const { postData: createNewStudentProfile, data: newStudent, error: error5, errorMessage: errorMessage5, isPending: isPending5 } = useFetch(`https://dcregapi.bi-oss.co.za/students/create`, 'POST')


    const [primaryPID, setPrimaryPID] = useState(parentID)
    const [primaryRel, setPrimaryRel] = useState('')


    const [success, setSuccess] = useState(0)
    const [firstPage, setFirstPage] = useState(1)
    const [secondPage, setSecondPage] = useState(0)
    const [thirdPage, setThirdPage] = useState(0)
    const [fourthPage, setFourthPage] = useState(0)
    const [fifthPage, setFifthPage] = useState(0)
    const [sixthPage, setSixthPage] = useState(0)

    const [firstNames, setFirstNames] = useState('')
    const [lastNames, setLastNames] = useState('')
    const [dob, setDob] = useState('')
    const [gender, setGender] = useState('')
    const [nation, setNation] = useState('South African')
    const [idpass, setIdPass] = useState('')
    const [email, setEmail] = useState('')
    const [mobile, setMobile] = useState('')
    const [raceId, setRaceId] = useState(null)
    const [homeLangId, setHomeLangId] = useState(1)
    const [prevSchool, setPrevSchool] = useState('')
    const [prevGrade, setPrevGrade] = useState('')
    const [advisor, setAdvisor] = useState(3)
    const [previousCandidate, setPreviousCandidate] = useState('')
    const [previousCenter, setPreviousCenter] = useState('')



    //second parent

    const [pid2, setPid2] = useState('')
    const [p2Nation, setP2Nation] = useState('South African')
    const [p2IdPass, setP2IdPass] = useState('')
    const [p2Relastionship, setP2Relationship] = useState('')
    const [p2DisplayName, setP2DisplayName] = useState('')
    const [p2title, setP2Title] = useState('')
    const [p2Fname, setP2Fname] = useState('')
    const [p2Lname, setP2Lname] = useState('')
    const [p2Gender, setP2Gender] = useState('')
    const [p2RaceId, setP2RaceId] = useState('')
    const [p2SaMobile, setP2SaMobile] = useState('')
    const [p2Worktel, setP2WorkTel] = useState('')
    const [p2HomeTel, setP2HomeTel] = useState('')
    const [P2LanguageId, setP2LanguageId] = useState('')
    const [p2Email, setP2Email] = useState('')
    const [p2Dob, setP2Dob] = useState('')
    //address details
    const [numberunit, setNumberUnit] = useState('')
    const [street, setStreet] = useState('')
    const [suburb, setSuburb] = useState('')
    const [city, setCity] = useState('')
    const [province, setProvince] = useState('')
    const [country, setCountry] = useState('South Africa')
    const [code, setCode] = useState('')








    const handleSubmit1 = (e) => {
        e.preventDefault()

        CheckStudentIDPass({
            idpass
        })
    }


    useEffect(() => {
        if (studentIDPASSCheck) {
            setFirstPage(0)
            setSecondPage(1)
        }
    }, [studentIDPASSCheck])




    const handleBack1 = (e) => {

        setSecondPage(0)
        setFirstPage(1)
    }




    const handleSubmit2 = (e) => {
        e.preventDefault()
        CheckStudentEmail({
            email
        }
        )
    }

    useEffect(() => {
        if (studentEmailCheck) {
            setSecondPage(0)
            setThirdPage(1)
        }
    }, [studentEmailCheck])


    const handleSubmit3 = (e) => {
        e.preventDefault()
        CheckParentIDPASS({
            idpass: p2IdPass,
            primaryPID
        })
    }

    useEffect(() => {
        if (parentIDPASSCheck) {


            setPid2(parentIDPASSCheck.parentId)
            setP2DisplayName(parentIDPASSCheck.displayName)
            setThirdPage(0)
            setFourthPage(1)

        }
    }, [parentIDPASSCheck])




    const handleSubmit4 = (e) => {
        e.preventDefault()

        if (pid2 > 0) {
            setFourthPage(0)
            setFifthPage(1)
        }
        if (pid2 === 0) {
            CheckParentEmail({
                email: p2Email
            })
        }
    }


    useEffect(() => {
        if (parentEmailChecked) {
            setFourthPage(0)
            setFifthPage(1)
        }
    }, [parentEmailChecked])

    const handleSubmit5 = (e) => {
        e.preventDefault()

        setFifthPage(0)
        setSixthPage(1)
    }

    const handleSubmit6 = (e) => {
        e.preventDefault()

        createNewStudentProfile({
            primaryPID,
            primaryRel,
            firstNames,
            lastNames,
            dob,
            gender,
            nation,
            idpass,
            email,
            mobile,
            raceId,
            homeLangId,
            prevSchool,
            prevGrade,
            advisor,
            pid2,
            p2Nation,
            p2IdPass,
            p2Relastionship,
            p2title,
            p2Fname,
            p2Lname,
            p2Gender,
            p2RaceId,
            p2SaMobile,
            p2Worktel,
            p2HomeTel,
            P2LanguageId,
            p2Email,
            numberunit,
            street,
            suburb,
            city,
            province,
            country,
            code,
            p2Dob,
            previousCandidate,
            previousCenter

        })
    }

    useEffect(() => {
        if (newStudent) {
            setSuccess(1)
        }
    }, [newStudent])


    const handleSubmit7 = (e) => {
        e.preventDefault()
        setCreateStudent(0)
    }


    const BackFromSecondParent = (e) => {
        e.preventDefault()
        setSecondPage(1)
        setThirdPage(0)
    }
    return (
        <>



            <Container maxWidth="md">
                <Box mb={3} />
                <Typography variant="h3" component="h3" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                    Create new student
                </Typography>
                <Box mb={5} />
                {firstPage === 1 && !success && (

                    <>
                        <form onSubmit={handleSubmit1} autoComplete="off" >

                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>
                                <>
                                    <Grid item xs={12} >
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Typography variant="h6" component="h4" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                                Step 1: Enter student’s identity information.
                                            </Typography>


                                        </Box>
                                    </Grid>


                                    {!isPending && (

                                        <>

                                            <Grid item xs={12} >
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"

                                                >

                                                    <Typography variant="body2" component="p" color="secondary.main" sx={{ textAlign: 'center' }}>
                                                        <b>Please note:</b> Student results and certificates will be linked to the students assigned identification. Please ensure you enter the correct identification information.
                                                    </Typography>


                                                </Box>
                                            </Grid>

                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center" f
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <SelectNationality nation={nation} setNation={setNation} />
                                                </Box>


                                            </Grid>


                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <EnterIDPass nation={nation} setIdPass={setIdPass} idpass={idpass} />
                                                    <br />


                                                </Box>
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >

                                                </Box>

                                            </Grid>
                                        </>
                                    )}

                                    {errorMessage && (

                                        <Grid item xs={12} >
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"

                                            >

                                                <Typography variant="body2" component="p" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                                    {errorMessage}
                                                </Typography>
                                            </Box>

                                        </Grid>
                                    )}

                                    <Grid item xs={12}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >
                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}

                                                >

                                                    <Button fullWidth type="submit" color="primary" variant="contained">Continue</Button>


                                                </Box>

                                            </Grid>
                                        </Box>

                                    </Grid>
                                    <Box mb={5} />
                                    <Grid item xs={12}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >


                                            <Divider style={{ width: '100%', color: "primary.main" }} />
                                        </Box>

                                    </Grid>



                                    <Grid item xs={12}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >
                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}

                                                >

                                                    <Button fullWidth onClick={(e) => setCreateStudent(0)} color="primary" variant="contained">Cancel</Button>


                                                </Box>

                                            </Grid>
                                        </Box>
                                        <Box mb={5} />
                                    </Grid>


                                </>

                            </Grid>


                        </form>

                    </>
                )}




                {secondPage === 1 && !success && (

                    <>
                        <form onSubmit={handleSubmit2} autoComplete="off" >

                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>
                                <>
                                    <Grid item xs={12} >
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Typography variant="h6" component="h4" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                                Step 2: Enter student details.
                                            </Typography>


                                        </Box>
                                    </Grid>


                                    {!isPending && (

                                        <>



                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center" f
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <SelectNationality nation={nation} setNation={setNation} disabled={1} />
                                                </Box>


                                            </Grid>


                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <EnterIDPass nation={nation} setIdPass={setIdPass} idpass={idpass} disabled={1} />
                                                    <br />


                                                </Box>
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >

                                                </Box>

                                            </Grid>


                                            <Grid item xs={12}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >


                                                    <Divider style={{ width: '100%', color: "primary.main" }} />
                                                </Box>

                                            </Grid>

                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <TextField

                                                        id="fname"
                                                        label="Student First Names"
                                                        onChange={(e) => setFirstNames(e.target.value)}
                                                        value={firstNames}
                                                        fullWidth
                                                        required
                                                        autoComplete='nope'
                                                        inputProps={{ maxLength: 100, minLength: 3, }}
                                                    />
                                                </Box>


                                            </Grid>



                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <TextField

                                                        id="lname"
                                                        label="Student Last Name"
                                                        onChange={(e) => setLastNames(e.target.value)}
                                                        value={lastNames}
                                                        fullWidth
                                                        required
                                                        autoComplete='nope'
                                                        inputProps={{ maxLength: 100, minLength: 3, }}
                                                    />


                                                </Box>


                                            </Grid>



                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >



                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DatePicker
                                                            label="Student DOB* (yyyy/MM/dd)"
                                                            inputFormat="yyyy/MM/dd"
                                                            value={dob}
                                                            onChange={(value) => setDob(value)}
                                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                                            required
                                                        />

                                                    </LocalizationProvider>


                                                </Box>


                                            </Grid>



                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <SelectGender gender={gender} setGender={setGender} />
                                                </Box>


                                            </Grid>


                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <SelectRace setRaceId={setRaceId} raceId={raceId} />

                                                </Box>


                                            </Grid>






                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <SelectSALang languageId={homeLangId} setLanguageId={setHomeLangId} label="Select Home Language" />

                                                </Box>


                                            </Grid>





                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <TextField

                                                        id="prevSchool"
                                                        label="Previous School"
                                                        onChange={(e) => setPrevSchool(e.target.value)}
                                                        value={prevSchool}
                                                        fullWidth
                                                        type="tel"
                                                        inputProps={{ maxLength: 100, minLength: 4, }}
                                                        autoComplete='nope'
                                                        required

                                                    />


                                                </Box>


                                            </Grid>

                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <SelectPreviousGrade prevGrade={prevGrade} setPrevGrade={setPrevGrade} />


                                                </Box>


                                            </Grid>
                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <TextField

                                                        id="number"
                                                        label="Student SA Mobile/Comms"
                                                        onChange={(e) => setMobile(e.target.value)}
                                                        value={mobile}
                                                        fullWidth
                                                        type="tel"
                                                        inputProps={{ maxLength: 10, minLength: 10, }}
                                                        autoComplete='nope'

                                                    />


                                                </Box>


                                            </Grid>

                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >


                                                    <EnterEmail email={email} setEmail={setEmail} required={true} />




                                                </Box>

                                            </Grid>

                                            <Grid item xs={12} >
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"

                                                >

                                                    <Typography variant="p" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                                        <b>Please Note:</b> Should the student be a previous Cambridge candidate and would like to link or improve upon previous qualifications, please complete the below details.
                                                    </Typography>


                                                </Box>
                                            </Grid>

                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <TextField

                                                        id="previousCandidate"
                                                        label="Previous Cambridge Candidate Number (Optional)"
                                                        onChange={(e) => setPreviousCandidate(e.target.value)}
                                                        value={previousCandidate}
                                                        fullWidth

                                                        autoComplete='nope'
                                                        inputProps={{ maxLength: 6, minLength: 4, }}
                                                    />
                                                </Box>


                                            </Grid>
                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <TextField

                                                        id="previousCenter"
                                                        label="Previous Cambridge Center Number (Optional)"
                                                        onChange={(e) => setPreviousCenter(e.target.value)}
                                                        value={previousCenter}
                                                        fullWidth

                                                        autoComplete='nope'
                                                        inputProps={{ maxLength: 8, minLength: 4, }}
                                                    />
                                                </Box>


                                            </Grid>
                                            {errorMessage2 && (

                                                <Grid item xs={12} >
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"

                                                    >

                                                        <Typography variant="body2" component="p" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                                            {errorMessage2}
                                                        </Typography>
                                                    </Box>

                                                </Grid>
                                            )}



                                        </>
                                    )}




                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >

                                            <Button fullWidth onClick={handleBack1} color="primary" variant="contained">Back</Button>


                                        </Box>

                                    </Grid><Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >
                                            {dob && !isPending && (

                                                <Button fullWidth type="submit" color="primary" variant="contained">Continue</Button>

                                            )}
                                            {!dob && (

                                                <Button fullWidth disabled color="primary" variant="contained">Continue</Button>

                                            )}

                                        </Box>

                                    </Grid>
                                    <Box mb={5} />
                                    <Grid item xs={12}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >


                                            <Divider style={{ width: '100%', color: "primary.main" }} />
                                        </Box>

                                    </Grid>



                                    <Grid item xs={12}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >
                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}

                                                >

                                                    <Button fullWidth onClick={(e) => setCreateStudent(0)} color="primary" variant="contained">Cancel</Button>


                                                </Box>

                                            </Grid>
                                        </Box>
                                        <Box mb={5} />
                                    </Grid>


                                </>

                            </Grid>


                        </form>

                    </>
                )}

                {thirdPage === 1 && !success && (
                    <>

                        <form onSubmit={handleSubmit3} autoComplete="off" >

                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>
                                <>
                                    <Grid item xs={12} >
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Typography variant="h6" component="h4" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                                Step 3: Enter second Parent or Guardians identity information.
                                            </Typography>


                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Typography variant="body2" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                                Please note, BIDC requires the details of the student's second legal parent or guardian as a contact in case of emergencies. This contact will have access to the student’s results and registration information.

                                            </Typography>


                                        </Box>
                                    </Grid>


                                    {!isPending3 && (

                                        <>



                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center" f
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <SelectNationality nation={p2Nation} setNation={setP2Nation} />
                                                </Box>


                                            </Grid>


                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                    <EnterIDPass nation={p2Nation} setIdPass={setP2IdPass} idpass={p2IdPass} />
                                                    <br />


                                                </Box>
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}
                                                >

                                                </Box>

                                            </Grid>
                                        </>
                                    )}

                                    {errorMessage3 && (

                                        <Grid item xs={12} >
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"

                                            >

                                                <Typography variant="body2" component="p" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                                    {errorMessage3}
                                                </Typography>
                                            </Box>

                                        </Grid>
                                    )}
                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >

                                            <Button fullWidth onClick={(e) => BackFromSecondParent()} color="primary" variant="contained">Back</Button>


                                        </Box>

                                    </Grid>
                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >

                                            <Button fullWidth type="submit" color="primary" variant="contained">Continue</Button>


                                        </Box>

                                    </Grid>
                                    <Box mb={5} />
                                    <Grid item xs={12}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >


                                            <Divider style={{ width: '100%', color: "primary.main" }} />
                                        </Box>

                                    </Grid>



                                    <Grid item xs={12}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >
                                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{

                                                        maxWidth: '95%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto'
                                                    }}

                                                >

                                                    <Button fullWidth onClick={(e) => setCreateStudent(0)} color="primary" variant="contained">Cancel</Button>


                                                </Box>

                                            </Grid>
                                        </Box>
                                        <Box mb={5} />
                                    </Grid>


                                </>

                            </Grid>


                        </form>

                    </>

                )}


                {fourthPage === 1 && pid2 > 0 && !success && (
                    <>

                        <form onSubmit={handleSubmit4} autoComplete="off" >

                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="h6" component="h4" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            Step 4: Verify second parent or guardian details.
                                        </Typography>


                                    </Box>
                                </Grid>

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            The identity information supplied has been found on our database belonging to the following registered parent of guardian:
                                        </Typography>


                                    </Box>
                                </Grid>
                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            <b>{p2DisplayName}</b>
                                        </Typography>


                                    </Box>
                                </Grid>
                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            If this is the person you wish to link as the student’s profile, then select the parent or guardian’s relationship with the student and click continue.
                                        </Typography>


                                    </Box>
                                </Grid>


                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <SelectRelationship relationship={p2Relastionship} setRelationship={setP2Relationship} />
                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        <Button fullWidth type="submit" color="primary" variant="contained">Continue</Button>


                                    </Box>

                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >


                                        <Divider style={{ width: '100%', color: "primary.main" }} />
                                    </Box>

                                </Grid>

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            If this is in error, then cancel the student creation and contact British International Distance College directly.
                                        </Typography>


                                    </Box>
                                </Grid>

                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}

                                            >

                                                <Button fullWidth onClick={(e) => setCreateStudent(0)} color="primary" variant="contained">Cancel</Button>


                                            </Box>

                                        </Grid>
                                    </Box>
                                    <Box mb={5} />
                                </Grid>
                            </Grid>
                        </form>


                    </>

                )}
                {fourthPage === 1 && pid2 === 0 && !success && (
                    <>


                        <form onSubmit={handleSubmit4} autoComplete="off" >

                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="h6" component="h4" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            Step 4: Enter second Parent or Guardians details.
                                        </Typography>


                                    </Box>
                                </Grid>





                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <SelectNationality nation={p2Nation} setNation={setP2Nation} disabled={1} />
                                    </Box>


                                </Grid>


                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <EnterIDPass nation={p2Nation} setIdPass={setP2IdPass} idpass={p2IdPass} disabled={1} />
                                        <br />


                                    </Box>


                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >


                                        <Divider style={{ width: '100%', color: "primary.main" }} />
                                    </Box>

                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <SelectRelationship relationship={p2Relastionship} setRelationship={setP2Relationship} />
                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <SelectTitle title={p2title} setTitle={setP2Title} />
                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <TextField

                                            id="fname"
                                            label="First Names"
                                            value={p2Fname}
                                            fullWidth
                                            required
                                            onChange={(e) => setP2Fname(e.target.value)}
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />
                                    </Box>


                                </Grid>


                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <TextField

                                            id="lname"
                                            label="Last Name"
                                            value={p2Lname}
                                            fullWidth
                                            required
                                            onChange={(e) => setP2Lname(e.target.value)}
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />
                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <FormControl fullWidth>
                                            <InputLabel id="genderL">Gender*</InputLabel>

                                            <Select

                                                labelId="genderL"
                                                id="Gender"
                                                value={p2Gender}
                                                onChange={(e) => setP2Gender(e.target.value)}
                                                input={<OutlinedInput label="genderL" />}
                                                required

                                            >
                                                <MenuItem value="M">Male</MenuItem>
                                                <MenuItem value="F">Female</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <SelectRace setRaceId={setP2RaceId} raceId={p2RaceId} />
                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >



                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="Parent DOB* (yyyy/MM/dd)"
                                                inputFormat="yyyy/MM/dd"
                                                value={p2Dob}
                                                onChange={(value) => setP2Dob(value)}
                                                renderInput={(params) => <TextField {...params} fullWidth />}
                                                required
                                            />

                                        </LocalizationProvider>


                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <TextField

                                            id="saMobile"
                                            label="Parent SA Mobile/Comms"
                                            onChange={(e) => setP2SaMobile(e.target.value)}
                                            value={p2SaMobile}
                                            fullWidth
                                            type="tel"
                                            inputProps={{ maxLength: 10, minLength: 10 }}
                                            autoComplete='nope'
                                            required
                                        />
                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <TextField

                                            id="workTel"
                                            label="Work Tel"
                                            value={p2Worktel}
                                            fullWidth
                                            type="tel"
                                            inputProps={{ maxLength: 15, minLength: 10, }}
                                            onChange={(e) => setP2WorkTel(e.target.value)}
                                            required
                                            autoComplete='nope'
                                        />
                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <TextField

                                            id="homeTel"
                                            label="Home Tel"
                                            value={p2HomeTel}
                                            fullWidth
                                            type="tel"
                                            inputProps={{ maxLength: 15, minLength: 10, }}
                                            onChange={(e) => setP2HomeTel(e.target.value)}
                                            required
                                            autoComplete='nope'
                                        />
                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <SelectSALang languageId={P2LanguageId} setLanguageId={setP2LanguageId} label="Home Language" />

                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <TextField
                                            id="emailbox"
                                            label="Email/Username:"
                                            variant="outlined"
                                            type="email"
                                            required
                                            onChange={(e) => setP2Email(e.target.value)}
                                            value={p2Email}
                                            fullWidth
                                            autoComplete='email'
                                            autoFocus

                                        />
                                    </Box>


                                </Grid>
                                {errorMessage4 && (

                                    <Grid item xs={12} >
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Typography variant="body2" component="p" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                                {errorMessage4}
                                            </Typography>
                                        </Box>

                                    </Grid>
                                )}

                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}

                                            >

                                                <Button fullWidth type="submit" color="primary" variant="contained">Continue</Button>


                                            </Box>

                                        </Grid>
                                    </Box>

                                </Grid>
                                <Box mb={5} />
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >


                                        <Divider style={{ width: '100%', color: "primary.main" }} />
                                    </Box>

                                </Grid>



                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}

                                            >

                                                <Button fullWidth onClick={(e) => setCreateStudent(0)} color="primary" variant="contained">Cancel</Button>


                                            </Box>

                                        </Grid>
                                    </Box>
                                    <Box mb={5} />
                                </Grid>
                            </Grid>

                        </form>




                    </>

                )}




                {fifthPage === 1 && !success && (
                    <>

                        <form onSubmit={handleSubmit5} autoComplete="off">
                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>
                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="h6" component="h4" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            Step 5: Enter student’s South African delivery address.
                                        </Typography>


                                    </Box>
                                </Grid>

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            This address will be used to deliver course material and certificates.
                                        </Typography>


                                    </Box>
                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >

                                        <TextField

                                            id="country"
                                            label="Country"
                                            value={country}
                                            disabled
                                            fullWidth
                                            required
                                            autoComplete='nope'

                                        />




                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >


                                        <SelectSaProvince province={province} setProvince={setProvince} />







                                    </Box>


                                </Grid>


                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="city"
                                            label="City/Town"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="suburb"
                                            label="Suburb"
                                            value={suburb}
                                            onChange={(e) => setSuburb(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="street"
                                            label="Street Name"
                                            value={street}
                                            onChange={(e) => setStreet(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="numberunit"
                                            label="House/Building/Apartment Number"
                                            value={numberunit}
                                            onChange={(e) => setNumberUnit(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="code"
                                            label="Area/Postal/Zip Code"
                                            value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 20, minLength: 4, }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        <Button fullWidth type="submit" color="primary" variant="contained">Continue</Button>


                                    </Box>

                                </Grid>
                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Divider style={{ width: '100%', color: "primary.main" }} />


                                    </Box>
                                </Grid>

                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}

                                            >

                                                <Button fullWidth onClick={(e) => setCreateStudent(0)} color="primary" variant="contained">Cancel</Button>


                                            </Box>

                                        </Grid>
                                    </Box>
                                    <Box mb={5} />
                                </Grid>

                            </Grid>
                        </form>




                    </>

                )}

                {sixthPage === 1 && !success && !isPending5 && (
                    <>
                        <form onSubmit={handleSubmit6} autoComplete="off">
                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>
                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="h6" component="h4" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            Step 6: Final Step
                                        </Typography>


                                    </Box>
                                </Grid>

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" color={success ? "success.main" : "secondary.main"} sx={{ textAlign: 'center' }}>
                                            Please confirm your relationship with the student.
                                        </Typography>


                                    </Box>
                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center" f
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <SelectRelationship relationship={primaryRel} setRelationship={setPrimaryRel} />
                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        <Button fullWidth type="submit" color="primary" variant="contained">Create Student</Button>


                                    </Box>

                                </Grid>
                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Divider style={{ width: '100%', color: "primary.main" }} />


                                    </Box>
                                </Grid>

                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}

                                            >

                                                <Button fullWidth onClick={(e) => setCreateStudent(0)} color="primary" variant="contained">Cancel</Button>


                                            </Box>

                                        </Grid>
                                    </Box>
                                    <Box mb={5} />
                                </Grid>
                            </Grid>
                        </form>
                    </>
                )}

                {success === 1 && (
                    <form onSubmit={handleSubmit7} autoComplete="off" >
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'success.main', }}>

                            <Grid item xs={12} >
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >

                                    <Typography variant="h6" component="h4" color="success.main" sx={{ textAlign: 'center' }}>
                                        New student created successfully.
                                    </Typography>


                                </Box>
                            </Grid>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >

                                            <Button fullWidth type="submit" color="success" variant="contained">Close</Button>


                                        </Box>

                                    </Grid>
                                </Box>
                                <Box mb={5} />
                            </Grid>
                        </Grid>
                    </form>
                )}

                {isPending5 && (

                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderRadius: 2, borderColor: 'secondary.main', }}>

                        <Grid item xs={12} >
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >

                                <Typography variant="h6" component="h4" color="secondary.main" sx={{ textAlign: 'center' }}>
                                    Creating new student profile....
                                </Typography>


                            </Box>
                        </Grid>
                        <Grid item xs={12} >
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <CircularProgress />

                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Container>

        </>
    )
}

export default CreateStudent